import script from "./IconPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./IconPicker.vue?vue&type=script&setup=true&lang=js"

import "./IconPicker.vue?vue&type=style&index=0&id=ddd2dd8a&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddd2dd8a"]])

export default __exports__